import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import "./style.css";

const NavBar = () => {

  const handleCollapse = () => {
    var nav = document.getElementById("navbarNavAltMarkup");
    var btn = document.getElementById("navbarBtn");
    nav.classList.remove("show");
    btn.classList.add("collapsed");
  };

  return (
    <nav class="navbar sticky-top navbar-expand-lg">
      <div class="container-fluid">
        <button
          class="navbar-toggler collapsed"
          type="button"
          id="navbarBtn"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <LinkContainer to="/">
          <a
            class="navbar-brand"
            href="home"
            style={
              window.innerWidth > 600
                ? { marginLeft: "50px" }
                : { marginRight: "25px" }
            }
            onClick={handleCollapse}
          >
            <img className="logo-img" src="logo.png" alt="logo" />
          </a>
        </LinkContainer>
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
          <ul class="navbar-nav ms-auto">
            <LinkContainer to="/about">
              <li class="nav-item">
                <a class="nav-link" href="about" onClick={handleCollapse}>
                  about us
                </a>
              </li>
            </LinkContainer>
            <LinkContainer to="/prices">
              <li class="nav-item">
                <a class="nav-link" href="prices" onClick={handleCollapse}>
                  prices
                </a>
              </li>
            </LinkContainer>
            <LinkContainer to="/schedule">
              <li class="nav-item">
                <a class="nav-link" href="schedule" onClick={handleCollapse}>
                  schedule
                </a>
              </li>
            </LinkContainer>
            <LinkContainer to="/contacts">
              <li class="nav-item">
                <a class="nav-link" href="contacts" onClick={handleCollapse}>
                  contacts
                </a>
              </li>
            </LinkContainer>
            <LinkContainer to="/blog">
              <li class="nav-item">
                <a class="nav-link" href="blog" onClick={handleCollapse}>
                  blog
                </a>
              </li>
            </LinkContainer>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
